import { CustomerRequest, PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { apiClient } from '.';

export const searchCustomerRequests = async (query?: SearchPagenateQuery) => {
  return apiClient.get<PagenatedResponse<CustomerRequest>>(`/admin/v1/customer-requests`, {
    params: query,
  });
};
